/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import {
  Table,
  Panel,
} from 'react-bootstrap';
import RichLabel from 'loracoms/RichLabel';
import SearchFlag from 'loracoms/SearchFlag';
import TablePager from 'loracoms/TablePager';
import ShowIf from 'loracoms/ShowIf';
import SortBtn from 'loracoms/SortBtn';
import LoadingTable from 'loracoms/LoadingTable';
import { normalizeAppEUI } from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import appActions from 'loraactions/app';
import styles from './styles.scss';

const defaultProps = {
  searching: false,
  searchText: '',
  count: 1,
};

const propTypes = {
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  searching: React.PropTypes.bool,
  searchText: React.PropTypes.string,
  apps: React.PropTypes.object.isRequired,
  getApps: React.PropTypes.func.isRequired,
  count: React.PropTypes.number,
};
let searchTxt = '';
class ApplicationList extends React.Component {

  static q(s) {
    const q = s.replace(/[:-]/g, '');
    return `or,APPEUI:*${q}*,name:*${q}*`;
  }

  constructor(props) {
    super(props);
    this.state = {
      count: props.count,
      searching: props.searching,
      apps: props.apps,
      sort: '',
      initialStatus: 'pending',
    };
    this.intlMsg = new IntlMsg(props.intl, 'application');
    this.handlePaging = this.handlePaging.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  componentWillMount() {
    const { getApps } = this.props;
    getApps({ count: true, tkcnt: true, pageSize: 20 });
  }

  componentWillReceiveProps(nextProps) {
    const { searching, searchText, apps, count } = nextProps;
    if (searching !== this.props.searching) {
      this.setState({ searching });
    }
    if (searchText !== this.props.searchText) {
      this.setState({ reset: Math.random() });
      const { getApps } = this.props;
      const { sort } = this.state;
      if (searchText !== '') {
        this.q = ApplicationList.q(searchText);
        searchTxt = this.q;
        getApps({ q: this.q, count: true, tkcnt: true, sort, pageSize: 20 });
      } else {
        this.q = null;
        searchTxt = '';
        getApps({ count: true, tkcnt: true, sort, pageSize: 20 });
      }
    }
    if (apps !== this.props.apps) {
      this.setState({ apps });
      if (apps.status === 'success') {
        const { data: { more, mark, list }, status } = apps;
        this.setState({ initialStatus: status, more, mark, list });
      } else if (apps.status === 'failure') {
        this.setState({ initialStatus: apps.status });
      }
    }
    if (count !== this.props.count) {
      this.setState({ count });
    }
  }

  handlePaging(mark) {
    const { getApps } = this.props;
    const { sort } = this.state;
    getApps({ mark, q: this.q, count: true, tkcnt: true, sort, pageSize: 20 });
  }

  handleSort(sort) {
    const { getApps } = this.props;
    this.setState({ sort, reset: Math.random() }, () => {
      getApps({ q: searchTxt, count: true, tkcnt: true, sort, mark: '', pageSize: 20 });
    });
  }

  render() {
    const { pushState } = this.props;
    const {
      searching = false,
      apps,
      reset,
      sort,
      initialStatus,
      mark = '',
      list = [],
      more = false,
    } = this.state;

    const header = (
      <div>
        <span>
          {this.intlMsg.msg('app.panelheader')}
        </span>
      </div>
    );

    const thead = (
      <thead>
        <tr>
          <th>
            {this.intlMsg.msg('app.fields.name')}
            <SearchFlag show={searching} />
            <SortBtn
              sortName="name"
              handleSort={this.handleSort}
              highLight={sort.indexOf('name') > -1}
            />
          </th>
          <th>
            APPEUI
            <SearchFlag show={searching} />
            <SortBtn
              sortName="appeui"
              handleSort={this.handleSort}
              highLight={sort.indexOf('appeui') > -1}
            />
          </th>
          <th>{this.intlMsg.msg('app.fields.devicenum')}</th>
          <th>{this.intlMsg.msg('app.fields.tokennum')}</th>
          <th>{this.intlMsg.msg('app.fields.target')}</th>
        </tr>
      </thead>
    );

    const trs = list.map(a => (
      <tr key={a.id}>
        <td>
          <Link onClick={() => pushState(`/application/${a.id}`)}>{a.name}</Link>
        </td>
        <td>
          <Link onClick={() => pushState(`/application/${a.id}`)}>{normalizeAppEUI(a.appeui)}</Link>
        </td>
        <td>{apps.data && apps.data.nodeCounts[a.id]}</td>
        <td>
          <Link onClick={() => pushState(`/application/${a.id}/api`)}>
            {apps.data && apps.data.tokenCounts[a.id]}
          </Link>
        </td>
        <td>
          <RichLabel content={a.target} />
        </td>
      </tr>
    ));

    if (initialStatus === 'pending') {
      const { count = 1 } = this.state;
      const rows = Math.max(1, Math.min(10, count));
      return (
        <Panel bsStyle="aisz-white" header={header}>
          <LoadingTable
            cols={5}
            rows={rows}
            className="aisz-table-light"
            striped
            bordered
            responsive
          >
            {thead}
          </LoadingTable>
        </Panel>
      );
    }

    return (
      <Panel bsStyle="aisz-white" header={header}>
        <Table className="aisz-table-light" striped hover bordered responsive>
          {thead}
          <tbody>
            {trs}
          </tbody>
        </Table>
        <ShowIf if={list.length > 0}>
          <div className={styles.pager}>
            <TablePager
              status={apps.status}
              mark={mark}
              more={more}
              reset={reset}
              onPrev={this.handlePaging}
              onNext={this.handlePaging}
            />
          </div>
        </ShowIf>
        <ShowIf if={list.length === 0}>
          <div className={styles.noapp}>
            <h3>{this.intlMsg.msg('noapp')}</h3>
          </div>
        </ShowIf>
      </Panel>
    );
  }
}

ApplicationList.defaultProps = defaultProps;
ApplicationList.propTypes = propTypes;

const mapStateToProps = state => ({
  apps: state.app.getApps,
  count: state.usage.apps,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getApps: appActions.getApps,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ApplicationList));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationList/index.jsx